import numeral from "numeral";
const multiCurrency = (price) => {
    let afterPrice = 0;
    let format = '0,0.00'; 
    afterPrice = '₹'+ numeral(price).format(format);
    return afterPrice;
  };
  
export default multiCurrency;
  